import { useLang } from "../i18n/LangContext";

export default function EmptyState({ onAddManual }) {
  const { t } = useLang();
  return (
    <div
      data-testid="empty-state"
      className="flex flex-col items-center justify-center text-center py-20 px-6 al-fade-up"
    >
      <div className="relative mb-6">
        <img
          src="/agentelead-logo-full.png"
          alt="AgenteLead Pro — FIND. ENGAGE. GROW."
          data-testid="empty-state-logo"
          className="h-20 sm:h-24 object-contain mx-auto mb-4"
        />
        <svg width="180" height="120" viewBox="0 0 180 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="opacity-90">
          <rect x="10" y="10" width="160" height="100" rx="12" fill="#EFF6FF" />
          <path d="M10 70 L60 40 L110 70 L170 30" stroke="#BFDBFE" strokeWidth="2" fill="none" />
          <path d="M10 90 L50 70 L100 95 L170 65" stroke="#BFDBFE" strokeWidth="2" fill="none" />
          <circle cx="40" cy="45" r="3" fill="#93C5FD" />
          <circle cx="135" cy="85" r="3" fill="#93C5FD" />
          <circle cx="80" cy="100" r="3" fill="#93C5FD" />
          <g transform="translate(82,20)">
            <path d="M14 0C6.27 0 0 6.27 0 14c0 10.5 14 26 14 26s14-15.5 14-26C28 6.27 21.73 0 14 0z" fill="#1E3A8A" />
            <circle cx="14" cy="14" r="5" fill="#F59E0B" />
          </g>
        </svg>
      </div>
      <h2 className="text-2xl md:text-3xl font-bold text-[#111827] tracking-tight">
        {t("empty.title")}
      </h2>
      <p className="mt-3 max-w-xl text-[14px] text-[#6B7280] leading-relaxed">
        {t("empty.body")}{" "}
        {onAddManual ? (
          <button
            type="button"
            data-testid="empty-state-add-manual"
            onClick={onAddManual}
            className="text-[#3B82F6] font-medium underline underline-offset-2 decoration-dotted hover:text-[#1D4ED8] hover:decoration-solid transition-colors"
          >
            {t("empty.body_link")}
          </button>
        ) : (
          <span className="text-[#3B82F6] font-medium">{t("empty.body_link")}</span>
        )}
      </p>
    </div>
  );
}
